<template>
  <div class="app">
    <bd-main></bd-main>
    <!-- <Layout
      :resize="resize"
      :splits="splits">
      <bd-aside class="custom-drag"></bd-aside>
      <bd-main class="custom-drag"></bd-main>
    </Layout> -->
  </div>
</template>

<script>
// import { Layout } from 'vue-split-layout'
// import BdAside from '@/components/dashboard/main/thread/BdAside'
import BdMain from '@/components/dashboard/main/thread/BdMain'

export default {
  name: 'bd-online',
  components: { BdMain },
  data () {
    return {
      // resize: true,
      // splits: {
      //   dir: 'horizontal',
      //   first: 0,
      //   second: 1,
      //   split: '20%'
      // }
    }
  }
}
</script>

<style scope>
</style>
